import { render, staticRenderFns } from "./InstanceAvatarImgNotAvailable.vue?vue&type=template&id=b8e27b8c&scoped=true"
import script from "./InstanceAvatarImgNotAvailable.vue?vue&type=script&lang=js"
export * from "./InstanceAvatarImgNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./InstanceAvatarImgNotAvailable.vue?vue&type=style&index=0&id=b8e27b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e27b8c",
  null
  
)

export default component.exports